import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { SITE } from "../lib/site";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#080808] border-t border-neutral-900 py-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex h-8 w-8 items-center justify-center bg-yellow-500 text-black font-black font-display">
                L
              </span>
              <span className="font-display font-semibold text-white text-lg">
                {SITE.expertName}
              </span>
            </div>
            <p className="text-neutral-400 max-w-md text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-6 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-yellow-400">
              {t.footer.auth}
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="overline mb-4">{t.nav.contact}</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href={`tel:${SITE.phoneRaw}`}
                  data-testid="footer-phone"
                  className="text-neutral-300 hover:text-yellow-400 transition-colors"
                >
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="text-neutral-300 hover:text-yellow-400 transition-colors break-all"
                >
                  {SITE.email}
                </a>
              </li>
              <li className="text-neutral-400">{SITE.address}</li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="overline mb-4">{t.nav.services}</div>
            <ul className="space-y-2 text-sm text-neutral-300">
              <li>
                <a
                  href="#services"
                  data-testid="footer-link-expertize"
                  className="hover:text-yellow-400 transition-colors"
                >
                  {t.services.items[0].title.split("&")[0].trim()}
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  data-testid="footer-link-evaluare"
                  className="hover:text-yellow-400 transition-colors"
                >
                  {t.services.items[1].title}
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  data-testid="footer-link-cartografie"
                  className="hover:text-yellow-400 transition-colors"
                >
                  {t.services.items[2].title}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-neutral-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs font-mono-tech text-neutral-500 uppercase tracking-[0.2em]">
          <span>
            © {year} {SITE.expertName}. {t.footer.rights}
          </span>
          <div className="flex items-center gap-5">
            <a
              href="/confidentialitate"
              data-testid="footer-privacy-link"
              className="hover:text-yellow-400 transition-colors"
            >
              {t.footer.privacy}
            </a>
            <span>Made with precision</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
